<template>
  <div class="permission-denied">
    <i class="far fa-lock"></i>
    <span class="pr-4"> Permission Denied </span>
    <div class="message">You don't have permissions to access this page</div>
  </div>
</template>


<style scoped>
.permission-denied {
  font-size: 40px;
  flex-direction: column;
  color: #94cad5;
  top: 20%;
  position: absolute;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.message {
  font-size: 20px;
  color: #222;
}
</style>


<script>
export default {
  name: "PermissionDenied",
  data () {
    return {}
  }
}
</script>
